var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.799 22 22.5 17.5228 22.5 12C22.5 6.47715 17.799 2 12 2C6.20101 2 1.5 6.47715 1.5 12C1.5 17.5228 6.20101 22 12 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09922 13.4294C7.87242 13.4294 8.49922 12.7898 8.49922 12.0008C8.49922 11.2119 7.87242 10.5723 7.09922 10.5723C6.32602 10.5723 5.69922 11.2119 5.69922 12.0008C5.69922 12.7898 6.32602 13.4294 7.09922 13.4294Z",
    fill: "url(#paint0_linear_35_1926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 13.4294C12.7709 13.4294 13.3977 12.7898 13.3977 12.0008C13.3977 11.2119 12.7709 10.5723 11.9977 10.5723C11.2245 10.5723 10.5977 11.2119 10.5977 12.0008C10.5977 12.7898 11.2245 13.4294 11.9977 13.4294Z",
    fill: "url(#paint1_linear_35_1926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 13.4294C17.6732 13.4294 18.3 12.7898 18.3 12.0008C18.3 11.2119 17.6732 10.5723 16.9 10.5723C16.1268 10.5723 15.5 11.2119 15.5 12.0008C15.5 12.7898 16.1268 13.4294 16.9 13.4294Z",
    fill: "url(#paint2_linear_35_1926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37164 21.599L7.85764 20.6419C8.26364 20.5276 8.40364 20.0133 8.10964 19.699L5.56164 17.099C5.26764 16.799 4.74964 16.9276 4.63764 17.3562L3.69964 20.9133C3.58764 21.3276 3.96564 21.7133 4.37164 21.599Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_1926",
    x1: 5.69922,
    y1: 12.0008,
    x2: 8.49922,
    y2: 12.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_1926",
    x1: 10.5977,
    y1: 12.0008,
    x2: 13.3977,
    y2: 12.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_1926",
    x1: 15.5,
    y1: 12.0008,
    x2: 18.3,
    y2: 12.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(1.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.26754248ac1371408213e4449adb163e.svg";
export { ForwardRef as ReactComponent };